import { makeStyles, Theme } from '@material-ui/core'
import React, { useState } from 'react'
import { Elements } from '@tfo/common'
import { useIntl } from 'react-intl'
const { Paragraph } = Elements
interface DropzoneProps {
	files: any[]
	onFilesAdded: (fileArray: File[]) => void
	submitError: boolean
}

const useStyles = makeStyles<Theme, { highlighted; submitError }>(theme => ({
	Dropzone: ({ highlighted, submitError }) => ({
		height: '100px',
		width: '100%',
		backgroundColor: highlighted ? 'rgb(173, 230, 247)' : '#fff',
		border: submitError ? '2px dashed #D10074' : `2px dashed #DFDFDE`,
		color: `##3D3D3C`,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		fontSize: '16px'
	}),

	Icon: {
		opacity: 0.3,
		height: '40px',
		width: '40px',
		display: 'inline'
	},

	FileInput: {
		display: 'none'
	},
	Paragraph: {
		width: '50px'
	},
	ResetMargin: {
		margin: '0'
	}
}))

const Dropzone: React.FC<DropzoneProps> = ({
	files, //this property is needed to trigger rerendering of the component
	onFilesAdded: propOnFilesAdded,
	submitError,

}: DropzoneProps) => {
	const intl = useIntl()
	const [highlighted, setHighlighted] = useState(false)
	const styles = useStyles({ highlighted, submitError })
	const fileInputRef = React.createRef<any>()
	const parentFilesAdd = (list: FileList) => propOnFilesAdded([...list])

	const openFileDialog = () => {
		fileInputRef.current.click()
	}

	const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault()
		setHighlighted(true)
	}

	const onDragLeave = () => {
		setHighlighted(false)
	}

	const onDrop = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault()
		parentFilesAdd(event.dataTransfer.files)
		setHighlighted(false)
	}

	return (
		<div
			className={styles.Dropzone}
			onClick={openFileDialog}
			onDragLeave={onDragLeave}
			onDragOver={onDragOver}
			onDrop={onDrop}>
			<input
				className="FileInput"
				multiple
				onChange={e => parentFilesAdd(e.target.files)}
				ref={fileInputRef}
				value={''} //this is a hack, when rerendering the component we empty the internal state of the object to successfull upload a file that have been after an intial upload removed.
				type="file"
				accept='.pdf'
			/>
			<img
				alt="upload"
				className={styles.Icon}
				src="/baseline-cloud_upload-24px.svg"
			/>
			<Paragraph className={styles.ResetMargin}>{intl.formatMessage({ id: 'common.attachFile' })}</Paragraph>
			<Paragraph className={styles.ResetMargin} small={true}>{intl.formatMessage({ id: 'common.attachFileSubtext' })}</Paragraph>
		</div>
	)
}

export default Dropzone
